'use client';

import { useMemo, type ReactElement } from 'react';
import { getParsedMindmapNodeCount } from './mindmap-derived-model';
import { MindmapCompactPreview } from './MindmapCompactPreview';
import { parseMermaidMindmap } from './parse-mermaid-mindmap';
import type { ParsedMindmap } from './mindmap-types';
import type { DataElScope } from '@/utils/dataEl';

interface UseCmarkdownmindmapParsedModelInput {
  content: string;
  dataElScope: DataElScope;
}

export interface CmarkdownmindmapParsedModel {
  compactPreview: ReactElement;
  nodeCount: number;
  parsed: ParsedMindmap | null;
}

export function useCmarkdownmindmapParsedModel({
  content,
  dataElScope,
}: UseCmarkdownmindmapParsedModelInput): CmarkdownmindmapParsedModel {
  const parsed = useMemo(() => parseMermaidMindmap(content), [content]);
  const nodeCount = useMemo(() => getParsedMindmapNodeCount(parsed), [parsed]);
  const compactPreview = useMemo(
    () => <MindmapCompactPreview dataElScope={dataElScope} parsed={parsed} />,
    [dataElScope, parsed],
  );

  return {
    compactPreview,
    nodeCount,
    parsed,
  };
}
